<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="h-4 w-4 {$$props.class}"
>
  <path
    d="M5 21V15M5 15V4C5 4 7.00871 3 9 3C10.9913 3 13.0087 5 15 5C16.9913 5 19 4 19 4V15C19 15 16.9913 16 15 16C13.0087 16 10.9913 14 9 14C7.00871 14 5 15 5 15Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="square"
  />
</svg>
